/** @file sheetTexture: a decoded sheet uploaded as an RGBA RawTexture (no mipmaps, no flip, clamped). */
import { RawTexture } from '@babylonjs/core/Materials/Textures/rawTexture.js';
import { Texture } from '@babylonjs/core/Materials/Textures/texture.js';
import type { Scene } from '@babylonjs/core/scene.js';
import type { Profile } from '@zilo/pose3d-format/types/profile';
import type { Image } from '@zilo/pose3d-image-io/types/image';

/**
 * `RawTexture.CreateRGBATexture(image.data, w, h, scene, false, false, mode)`: the image-io texels as they are (row 0
 * at v = 0, as raster reads them), nearest sampling for `nearest` profiles and bilinear otherwise, clamped edges.
 */
export function sheetTexture(scene: Scene, image: Image, sampling: Profile['sampling'], name: string): RawTexture {
  const mode = sampling === 'nearest' ? Texture.NEAREST_SAMPLINGMODE : Texture.BILINEAR_SAMPLINGMODE;
  const data = new Uint8Array(image.data.buffer, image.data.byteOffset, image.data.byteLength);
  const texture = RawTexture.CreateRGBATexture(data, image.width, image.height, scene, false, false, mode);
  texture.name = name;
  texture.wrapU = Texture.CLAMP_ADDRESSMODE;
  texture.wrapV = Texture.CLAMP_ADDRESSMODE;
  return texture;
}
